import { render } from "./HouseDimensionsAndInclusions.vue?vue&type=template&id=f738d478&scoped=true&ts=true&lang=pug"
import script from "./HouseDimensionsAndInclusions.vue?vue&type=script&lang=ts&setup=true"
export * from "./HouseDimensionsAndInclusions.vue?vue&type=script&lang=ts&setup=true"

import "./HouseDimensionsAndInclusions.vue?vue&type=style&index=0&id=f738d478&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f738d478"]])

export default __exports__